import { render, staticRenderFns } from "./SocialEmployeeMattersForm.vue?vue&type=template&id=b689d2da&scoped=true&lang=html&"
import script from "./SocialEmployeeMattersForm.vue?vue&type=script&lang=js&"
export * from "./SocialEmployeeMattersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b689d2da",
  null
  
)

export default component.exports